import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature15 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getBox(data) {
      const { left, right, img, ...other } = data;
      return (
        <TweenOne
          key="one"
          animation={{
            x: 0,
            duration: 1000,
          }}
          style={{ transform: 'translateX(-1000px)' }}
          {...other}
        >
          <div {...img}>
            <img src={img.children} alt="" />
          </div>
          <div className="row">
            <div {...left}>
              { left.children.map(getChildrenToRender) }
            </div>
            <div {...right}>
              { right.children.map(getChildrenToRender) }
            </div>
          </div>
        </TweenOne>
      );
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.page}>
          <div
            {...dataSource.content}
          >
            <div
              {...dataSource.content.left}
            >
              {getBox(dataSource.content.left.box)}
              <TweenOne
                key="two"
                animation={{
                  x: 0,
                  duration: 900,
                  delay: 150,
                }}
                style={{ transform: 'translateX(-1000px)' }}
                {...dataSource.content.left.title}
              >
                {dataSource.content.left.title.children.map(getChildrenToRender)}
              </TweenOne>
              <TweenOne
                animation={{
                  x: 0,
                  duration: 800,
                  delay: 300,
                }}
                style={{ transform: 'translateX(-1000px)' }}
                {...dataSource.content.left.imgs}
              >
                {
                dataSource.content.left.imgs.children.map(getChildrenToRender)
              }
              </TweenOne>
            </div>
            <TweenOne
              animation={{
                x: 0,
                duration: 1000,
              }}
              delay={300}
              style={{ transform: 'translateX(1000px)' }}
              {...dataSource.content.right}
            >
              <img src={dataSource.content.right.children} width="100%" alt="img" />
            </TweenOne>
          </div>
          <TweenOne
            animation={{
              scale: 1,
              duration: 1000,
            }}
            style={{ transform: 'scale(0)' }}
            {...dataSource.title}
          >
            {
            dataSource.title.children.map(getChildrenToRender)
          }
          </TweenOne>
        </div>
      </OverPack>
    );
  }
}
export default Feature15;
